module.exports = __webpack_public_path__ + "img/interface_title.cfa75a57.png";